import type {RouteObject} from 'react-router-dom';

export const routes = [
  {
    path: 'not-entitled',
    async lazy() {
      const {NotEntitled} = await import('./pages/NotEntitled');
      return {element: <NotEntitled />};
    },
  },
] as RouteObject[];
